import React, { useContext, useState } from 'react'
import STC from "../../../../STCLibrary/STCFactory/STCFactory";
import { useNavigate } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import { LoginAPIs } from '../../../../API/LoginAPIs/LoginAPIs';
import ApiResponseHandler from '../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler';
import NotificationContext from '../../../../STCLibrary/NotificationSystem/NotificationContext';
import { FaQuestionCircle } from "react-icons/fa";
 
function LoginForm({ setIsParent, setForgotPassword }) {
 
    const navigate = useNavigate();
    const notificationCtx = useContext(NotificationContext);
    const [sending, setSending] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [incorrect, setIncorrect] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [showWarning, setShowWarning] = useState(false);
 
    const handleSubmit = (e) => {
        e.stopPropagation();
        e.preventDefault();

        setSending(true);
        setIncorrect(false);
        setErrorMsg('');

       const postJSON = {
        username: username,
        // userId: username,
        password: password,
       }

       LoginAPIs.PostLogin(postJSON)
       .then((response) => {
        if(response.status === 200){
            if(!response.data.error){
                navigate('/' + response.data.id);
            }
            else{
                setIncorrect(true);
                setErrorMsg('Incorrect login details');
            }
        }
        setSending(false)
       })
       .catch((err) => {
        setSending(false)
        console.log(err);
        ApiResponseHandler(err.response, notificationCtx, navigate)
       })

    }
 
    const handleForgotPassword = () => {
        setForgotPassword(true);
    }
 
    return (
        <>
      

            

           
                {/* <STC.Alert variant='warning'>
                    <div className='text-center' onClick={()=>setShowWarning(!showWarning)}>
                        {showWarning ? 'Close' : 'Trouble Logging In'} <FaQuestionCircle/>
                        </div>
                    {showWarning &&
                    <>
                    <div>We are currently experiencing some Login issues for users on iOS devices (iPhones, iPads, MacBooks).</div> 
                    <div>If you are unable to login from one of these devices, please try using a Private or Incognito window, or use a Windows PC</div>
                    <div>We apologise for the inconvenience, we hope to have the issue fully resolved soon.</div>
                    </>
                    
                    }
                </STC.Alert> */}
            
        <STC.Form onSubmit={handleSubmit}>
             <div style={{ marginBottom: '10px' }}></div>
 
            <STC.Form.FloatingLabel className="mb-3">
                <Form.Control
                    id="floatingInputCustom"
                    type="email"
                    required
                    placeholder="name@example.com"
                    value={username}
                    disabled={sending}
                    onChange={(e) => setUsername(e.target.value)}
                    isInvalid={incorrect}
                />
                <label style={{marginLeft: '0.5rem'}} htmlFor="floatingInputCustom">Email</label>
            </STC.Form.FloatingLabel>
            <STC.Form.FloatingLabel>
                <Form.Control
                    id="floatingPasswordCustom"
                    required
                    type="password"
                    placeholder="Password"
                    value={password}
                    disabled={sending}
                    onChange={(e) => setPassword(e.target.value)}
                    isInvalid={incorrect}
                />
                <label style={{marginLeft: '0.5rem'}} htmlFor="floatingPasswordCustom">Password</label>
            </STC.Form.FloatingLabel>
       
            {incorrect && <STC.Alert className='mt-1' variant='danger'>{errorMsg}</STC.Alert>}
           
            <div align={'right'} className="mt-2">
                <STC.Button size="sm" disabled={sending} className={'cmn-button login-button'} type={'submit'} >{sending ? 'Submitting' : 'Submit'}</STC.Button>
            </div>

            

 
            <div className="mt-2 text-center">
                <span
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                    onClick={handleForgotPassword}
                >
                    Forgot Password?
                </span>
            </div>
        </STC.Form>
        </>
    )
}
export default LoginForm;
 